<!-- <order-tracker *ngIf="showTracker()" [orders]="orders"></order-tracker> -->

<div *ngIf="showTracker()" class="row m-0">
    <div class="col-12">
        <nav class="navbar ">
            <div class="sub-menu">
                <input type="checkbox" id="show-menu" role="button">
                <label for="show-menu" class="show-menu"></label>
                <ul class=" menu" id="menu">
                    <li>
                        <a class="menu__item " routerLink="/account/dashboard"><img src="./assets/img/dashboard/subm.png" alt="" width="15" /> Dashboard</a>
                    </li>
                    <li>
                        <a class="menu__item active" routerLink="/account/myorder"><img src="./assets/img/dashboard/order.png" alt="" width="15" /> My Orders</a>
                    </li>
                    <li>
                        <a class="menu__item " routerLink="/account/sellerready"><img src="./assets/img/dashboard/seller.png" alt="" width="15" /> Seller Ready</a>
                    </li>
                    <li>
                        <a class="menu__item " routerLink="/account/receipts"><img
                            src="../../../../assets/img/dashboard/Dollar Icon - Black - S.png"
                            alt=""
                            width="15"
                        />
                        Receipts
                    </a>
                    </li>
                    <li>
                        <a class="menu__item " routerLink="/account/needhelp"><img src="./assets/img/dashboard/helpp.png" alt="" width="15" /> I need Help</a>
                    </li>
                    <li>
                        <a class="menu__item " routerLink="/account"><img src="./assets/img/dashboard/user.png" alt="" width="15" />My Profile</a>
                    </li>
                </ul>

            </div>
        </nav>
    </div>
</div>

<router-outlet (activate)="onActivate($event)"></router-outlet>

<div class="footer" >
    <div class="footer__container">
        <div class="footer__logo">
            <img src="/assets/img/SGC_White-New.png" class="image-set-mobile" title="SGC Logo" alt="SGC White Logo" style="margin-top: -15px; margin-left: -30px;">
        </div>
        <div class="footer__col">
            <h4 style="color:white;">Contact</h4>
            <div class="footer__address">
                <p>SGC</p>
                <p>951 W YAMATO RD STE 101</p>
                <p>BOCA RATON FL 33431</p>
                <ul class="footer__menu">
                    <li>
                        <a routerLink="/collector-support" class="footer__menu-item">CONTACT US</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer__col">
            <h4 style="color:white;">Navigation</h4>
            <ul class="footer__menu">
                <!--<li><a routerLink="/culture" class="footer__menu-item">Culture</a></li>-->
                <li><a routerLink="/card-grading" class="footer__menu-item">Card Grading</a></li>
                <li><a routerLink="/pop-report" class="footer__menu-item">Pop report</a></li>
                <li><a routerLink="/cert-code-lookup" class="footer__menu-item">CERT VERIFICATION</a></li>
                <!--<li><a routerLink="/aboutus" class="footer__menu-item">About Us</a></li>-->
                <li><a routerLink="/collector-support" class="footer__menu-item">Collector Support</a></li>
                <li><a routerLink="/sgc-grading-app" class="footer__menu-item">Download App</a></li>
                <!--<li><a routerLink="/media" class="footer__menu-item">Media</a></li>
                <li><a routerLink="/old-homePage" class="footer__menu-item">Landing Page</a></li>
                <li><a routerLink="/original-homePage" class="footer__menu-item">Original</a></li>-->
                <!--<li><a routerLink="/revised-original" class="footer__menu-item">Revised Original</a></li>-->
            </ul>
        </div>
        <div class="footer__col">
            <h4 style="color:white;">My account</h4>
            <ul class="footer__menu">
                <li><a routerLink="/account/myorder" class="footer__menu-item">My Orders</a></li>
                <!-- <li><a routerLink="/" class="footer__menu-item">My reports</a></li> -->
                <li><a routerLink="/account" class="footer__menu-item">My profile</a></li>
                <li><a routerLink="/checkout" class="footer__menu-item">Start New Submission</a></li>
            </ul>
        </div>
        <div class="footer__col">
            <h4 style="color:white;">Download App</h4>
            <ul class="footer__menu"  style="cursor: pointer;">
                <img style="width: 100px; cursor: pointer;" routerLink="/sgc-grading-app" src="../../../../assets/img/blog/footerqrcode.png" alt="">
            </ul>
        </div>
        <div class="footer__col footer__col--right">
            <h4 class="icon-heading" style="color:white;margin-top: -30px; margin-right: 31px;
            ">Follow sgc grading</h4>
            <div class="followUsSocial_3" style="  position: relative;
            top: -33px; ;">
                    <a style="display:inline-block;padding-right:5px;"  href="https://www.instagram.com/sgcgrading" target="_blank"    >
                        <!-- Instagram Icon. -->
                        <img title=" Follow us on Instagram" src="/assets/img/InstagramIcon(inverted).png">
                    </a>
                <a style="display:inline-block;padding-right:5px;" href="https://www.facebook.com/sgcgrading" target="_blank">
                    <img title="Follow us on Facebook" src="/assets/img/FacebookIcon(inverted).png">
                </a>
                <a style="display:inline-block;padding-right:5px" href="https://twitter.com/sgcgrading" target="_blank">
                    <!-- thread Icon. -->
                    <img title="Follow us on X(Twitter)" src="/assets/img/thread.png">
                </a>
                <a style="display:inline-block; padding-right:5px" href="https://www.tiktok.com/@sgcgrading" target="_blank">
                    <!-- tiktok Icon -->
                    <img title=" Follow us on tiktok" src="/assets/img/tiktok_icon.png">
                </a>
                <a style="display:inline-block;padding-right:5px" href="https://youtube.com/@sgcgrading"  target="_blank">
                    <!-- thread Icon. -->
                    <img title="Follow us on Youtube" src="/assets/img/youtube_icon.png">
                </a>
            </div>
            <!-- <ul class="footer__social">
                <li><a href=""><img src="/assets/img/instagram.svg" alt="Instagram"></a></li>
                <li><a href=""><img src="/assets/img/facebook.svg" alt="Facebook"></a></li>
                <li><a href=""><img src="/assets/img/twitter.svg" alt="Twitter"></a></li>
                <li><a href=""><img src="/assets/img/youtube.svg" alt="YouTube"></a></li>
            </ul> -->
        </div>
        <div class="footer__copyright" style="display: flex; justify-content: space-between; " >
            <p>Copyright © 2025 SGC, LLC. All rights reserved.</p>
            <ul class="footer__menu" style="display: flex; gap: 30px;" >
                <li><a routerLink="/terms" class="footer__menu-item">Terms & conditions</a></li>
                <li><a routerLink="/privacy" class="footer__menu-item">Privacy Notice</a></li>
            </ul>
        </div>
    </div>
</div>